// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"e25639a7c1bbaeb8bd47","454":"48df562f374407363504"}[chunkId] + ".js";
};